// removed by extract-text-webpack-plugin
module.exports = {"loading-receipt":"app-pages-AccountSetting-Billing-BillingReceipt-__BillingReceipt___XO3QV","load-billing-receipt":"app-pages-AccountSetting-Billing-BillingReceipt-__BillingReceipt___1s0oq","billing-section":"app-pages-AccountSetting-Billing-BillingReceipt-__BillingReceipt___3cLcy"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/AccountSetting/Billing/BillingReceipt/BillingReceipt.css
// module id = 2273
// module chunks = 0